import { apiUrl, baseUrl, stage } from '../constants/apiUrl'
import { useAuth } from './useAuth'

interface ApiUrlProps {
  isDcp: boolean
  buildDeviceUrl: (deviceId: string, path?: string) => string
  buildUrl: (path: string) => string
}

export const useApiUrl = (): ApiUrlProps => {
  const auth = useAuth()
  const dcpBaseDomain = process.env.REACT_APP_DCP_BASE_DOMAIN
  const isDcp = dcpBaseDomain ? window.location.hostname.endsWith('.' + dcpBaseDomain) : false

  const buildDeviceUrl = (deviceId: string, path = '') =>
    isDcp
      ? `${baseUrl}${stage}${apiUrl.tenantsPath}${auth.tenant}${apiUrl.devicesPath}${deviceId}${path}`
      : `${baseUrl}${stage}${apiUrl.devicesPath}${deviceId}${path}`

  const buildUrl = (path: string) =>
    isDcp
      ? `${baseUrl}${stage}${apiUrl.tenantsPath}${auth.tenant}${path}`
      : `${baseUrl}${stage}${path}`

  return { isDcp, buildDeviceUrl, buildUrl }
}
